const apiConstants = ['mapPayload', 'deletePayload', 'clear'];

const apiGroups = [
  'baseStrings',
  'users',
  'projects',
  'localeStrings',
  'languages'
];

function generateApiConstants() {
  let groups = {};

  apiGroups.forEach(groupName => {
    if (!groups[groupName]) groups[groupName] = {};
    apiConstants.forEach(constant => {
      groups[groupName][constant] =
        groupName.toUpperCase() + '_' + constant.toUpperCase();
    });
  });
  return groups;
}

const STATIC_CONSTANTS = {
  auth: {
    forgotPassword: 'FORGOT_PASSWORD',
    resetPassword: 'RESET_PASSWORD',
    emailUnsubscribe: 'EMAIL_UNSUBSCRIBE'
  },
  config: {
    get: 'GET_CONFIG'
  },
  drawer: {
    open: 'OPEN_DRAWER',
    close: 'CLOSE_DRAWER'
  },
  loader: {
    open: 'OPEN_LOADER',
    close: 'CLOSE_LOADER'
  },
  localStorageSettings: {
    instantiateProjectStorage: 'INSTANTIATE_PROJECT_STORAGE',
    setLocalStorageSettings: 'SET_LOCAL_STORAGE_SETTINGS'
  },
  modals: {
    open: 'OPEN_MODAL',
    close: 'CLOSE_MODAL'
  },
  sessionSettings: {
    setSessionSettings: 'SET_SESSION_SETTINGS'
  },
  snackbar: {
    open: 'OPEN_SNACKBAR',
    close: 'CLOSE_SNACKBAR'
  },
  overlay: {
    open: 'OPEN_OVERLAY',
    close: 'CLOSE_OVERLAY'
  }
};

export const ACTION_CONSTANTS = Object.assign(
  STATIC_CONSTANTS,
  generateApiConstants()
);



// WEBPACK FOOTER //
// ./src/actions/constants.js